var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOrangeTimer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 70,
    viewBox: "0 0 44 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bfff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f33030"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_orange_timer",
    d: "M19.605,41.791a6.749,6.749,0,0,0,0-9.582l-.364-.359C12.421,25.119,7.153,19.921,5.565,9.026A6.292,6.292,0,0,1,12.016,2H42.984a6.292,6.292,0,0,1,6.452,7.026c-1.588,10.9-6.857,16.093-13.677,22.824l-.364.359a6.749,6.749,0,0,0,0,9.582l.364.359c6.82,6.732,12.089,11.929,13.677,22.825A6.292,6.292,0,0,1,42.984,72H12.016a6.292,6.292,0,0,1-6.452-7.026c1.588-10.9,6.857-16.093,13.677-22.825Zm2.312,5.942-.025.022c-5.2,4.806-9.065,8.384-9.569,17.232a1.663,1.663,0,0,0,.569,1.357,1.635,1.635,0,0,0,1.081.406H41.025a1.642,1.642,0,0,0,1.23-.552,1.664,1.664,0,0,0,.42-1.211c-.5-8.849-4.371-12.426-9.567-17.232-1.375-1.271-2.843-2.628-4.365-4.192a1.727,1.727,0,0,0-2.487,0c-1.514,1.554-2.973,2.905-4.338,4.17Z",
    transform: "translate(-5.5 -2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrangeTimer);
export default __webpack_public_path__ + "static/media/icon_orange_timer.bc745b1a5695320d22a91ac5818e862b.svg";
export { ForwardRef as ReactComponent };